export default __webpack_public_path__ + "static/media/gallery-wip-emitter_05.aaaed0a0.jpg";